import type { BoxTheme } from '@lub0v/santa-utils';
import { isSeason, DEFAULT_GAME_SEASON, type Season } from './season';

// One set of scene thumbnails for the home carousel, picker and Premium page.
const images = import.meta.glob<string>('../pages/NewBoxPage/assets/theme-previews/*.jpg', {
  eager: true, query: '?url', import: 'default',
});
export const themePreviewImage = (theme: Season | BoxTheme, mode: 'light' | 'dark') =>
  images[`../pages/NewBoxPage/assets/theme-previews/${isSeason(theme) ? theme : DEFAULT_GAME_SEASON}-${mode === 'light' ? 'day' : 'night'}.jpg`];
